import axios from "axios";
import { DataResponse, PaginatedResponse } from "models/common/responseObjects";
import { Store, StoreExtended, StoreLockDownView } from "models/dbModels/stores/Store";
import { StoreSearchFilterQuery } from "models/filters/stores/StoreSearchFilterQuery";

export class StoresApi {
    static Search = async (query: StoreSearchFilterQuery) => axios.post<PaginatedResponse<StoreExtended[]>>(`api/v1/Stores/Search`, query);
    static Add = async (query: Store[]) => axios.post<DataResponse<number[]>>(`api/v1/Stores/Add`, query);
    static Update = async (query: Store[]) => axios.post<DataResponse<boolean>>(`api/v1/Stores/Update`, query);
    static UpdateLockDownFields = async (query: StoreLockDownView[]) => axios.post<DataResponse<boolean>>(`api/v1/Stores/UpdateLockDownFields`, query);
}